import { render, staticRenderFns } from "./Nuevo-pase-cuenta-proveedor.vue?vue&type=template&id=cabdc158"
import script from "./Nuevo-pase-cuenta-proveedor.vue?vue&type=script&lang=js"
export * from "./Nuevo-pase-cuenta-proveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports